import React, { useState } from "react";
import {
  GoogleMap,
  InfoWindow,
  Marker,
  Polyline,
  withGoogleMap,
  withScriptjs
} from "react-google-maps";
import { compose, withProps } from "recompose";


const googleMapURL = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCC-gpzzG6hcmAyagvaYCc23KAy4rIkv2A&v=3.exp&libraries=geometry,drawing,places,visualization";

const BikeTrip = (props) => {
  const [selectedPlaceIndex, setSelectedPlaceIndex] = useState(false);

  const handleShowInfo = (index) => {
    setSelectedPlaceIndex(index);
  };

  const pathWithMarkers = props.pathCoordinates.filter(coordinate => !!coordinate.marker);

  const selectedPlace = selectedPlaceIndex !== false ? pathWithMarkers[selectedPlaceIndex] : false;

  return (
    <div>
      <GoogleMap
        defaultZoom={21}
        defaultCenter={props.pathCoordinates[0]}
      >
        {props.pathCoordinates && <Polyline
          path={props.pathCoordinates}
          options={{
            geodesic: true,
            strokeColor: "#FF2D00",
            strokeOpacity: 1.0,
            strokeWeight: 2,
            icons: [{
              icon: {
                // eslint-disable-next-line no-undef
                path: google.maps.SymbolPath.CIRCLE,
                strokeOpacity: 1,
                scale: 8,
                strokeColor: "#00F",
              },
              offset: "0%"
            }, {
              icon: {
                // eslint-disable-next-line no-undef
                path: google.maps.SymbolPath.CIRCLE,
                strokeOpacity: 1,
                scale: 8,
                strokeColor: "#E82",
              },
              offset: "100%"
            }],
          }}
        />}

        {pathWithMarkers.map((coordinate, index) => (
          <Marker
            key={index}
            position={{
              lng: coordinate.lng,
              lat: coordinate.lat
            }}
            onClick={() => handleShowInfo(index)}
          />
        ))}

        {selectedPlace ?
          <InfoWindow
            onCloseClick={() => handleShowInfo(false)}
            position={{
              lat: parseFloat(selectedPlace.lat),
              lng: parseFloat(selectedPlace.lng)
            }}
          >
            <div>
              <h5>{selectedPlace !== false ? selectedPlace.marker : ""}</h5>

              <div>lat: {selectedPlace.lat}</div>
              <div>lng: {selectedPlace.lng}</div>
            </div>
          </InfoWindow>
          : null}
      </GoogleMap>
    </div>
  );
};

export default compose(
  withProps({
    googleMapURL,
    loadingElement: <div style={{ height: "100%" }}/>,
    containerElement: <div style={{ height: "100%" }}/>,
    mapElement: <div style={{ height: "100%" }}/>,
  }),
  withScriptjs,
  withGoogleMap
)(BikeTrip);



// WEBPACK FOOTER //
// ./src/views/lib/components/maps/bike-trip.js